import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'

const handoffInput = z.object({
  conversationId: z.string().min(1),
  returnTo: z.string().min(1).optional(),
})

export const resolveAdminConversationImpersonation = createServerFn({
  method: 'POST',
})
  .inputValidator(handoffInput)
  .handler(async ({ data }) =>
    (
      await import('@server/admin-impersonation')
    ).resolveAdminConversationImpersonation({ data }),
  )
